import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found | DHIYAA SOLAR ENERGY" description="The page you are looking for does not exist." />
      <section className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center" data-testid="not-found">
        <p className="font-heading text-7xl font-extrabold text-brand-orange">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-brand-navy">This page has gone off-grid</h1>
        <p className="mt-2 max-w-md text-slate-600">The page you are looking for doesn't exist. Let's get you back to the sunshine.</p>
        <Link to="/" className="mt-6 rounded-full bg-brand-orange px-8 py-3.5 font-heading text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-brand-orangedark" data-testid="notfound-home-btn">
          Back to Home
        </Link>
      </section>
    </>
  );
}
